/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomDetail } from './RoomDetail';
import {
    RoomDetailFromJSON,
    RoomDetailFromJSONTyped,
    RoomDetailToJSON,
    RoomDetailToJSONTyped,
} from './RoomDetail';
import type { LineItemMatchGroup } from './LineItemMatchGroup';
import {
    LineItemMatchGroupFromJSON,
    LineItemMatchGroupFromJSONTyped,
    LineItemMatchGroupToJSON,
    LineItemMatchGroupToJSONTyped,
} from './LineItemMatchGroup';

/**
 * A group of matched rooms between insurer and contractor estimates
 * @export
 * @interface RoomMatchGroup
 */
export interface RoomMatchGroup {
    /**
     * Unique room match group ID
     * @type {number}
     * @memberof RoomMatchGroup
     */
    readonly id: number;
    /**
     * ID of the parent comparison
     * @type {number}
     * @memberof RoomMatchGroup
     */
    comparisonId: number;
    /**
     * How this room match group was created
     * @type {string}
     * @memberof RoomMatchGroup
     */
    creationStatus: RoomMatchGroupCreationStatusEnum;
    /**
     * User confirmation status of this room match
     * @type {string}
     * @memberof RoomMatchGroup
     */
    confirmationStatus?: RoomMatchGroupConfirmationStatusEnum | null;
    /**
     * AI confidence score for this room match
     * @type {number}
     * @memberof RoomMatchGroup
     */
    confidence: number | null;
    /**
     * Notes about this match (AI reasoning or user notes)
     * @type {string}
     * @memberof RoomMatchGroup
     */
    note?: string | null;
    /**
     * Matched rooms from the insurer estimate
     * @type {Array<RoomDetail>}
     * @memberof RoomMatchGroup
     */
    insurerRooms: Array<RoomDetail>;
    /**
     * Matched rooms from the contractor estimate
     * @type {Array<RoomDetail>}
     * @memberof RoomMatchGroup
     */
    contractorRooms: Array<RoomDetail>;
    /**
     * Line item match groups within these matched rooms
     * @type {Array<LineItemMatchGroup>}
     * @memberof RoomMatchGroup
     */
    lineItemMatchGroups: Array<LineItemMatchGroup>;
    /**
     * When the room match group was created
     * @type {Date}
     * @memberof RoomMatchGroup
     */
    createdAt?: Date;
    /**
     * When the room match group was last updated
     * @type {Date}
     * @memberof RoomMatchGroup
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const RoomMatchGroupCreationStatusEnum = {
    AiCreated: 'ai_created',
    UserCreated: 'user_created',
    UserUpdated: 'user_updated'
} as const;
export type RoomMatchGroupCreationStatusEnum = typeof RoomMatchGroupCreationStatusEnum[keyof typeof RoomMatchGroupCreationStatusEnum];

/**
 * @export
 */
export const RoomMatchGroupConfirmationStatusEnum = {
    Confirmed: 'confirmed',
    Rejected: 'rejected',
    Pending: 'pending'
} as const;
export type RoomMatchGroupConfirmationStatusEnum = typeof RoomMatchGroupConfirmationStatusEnum[keyof typeof RoomMatchGroupConfirmationStatusEnum];


/**
 * Check if a given object implements the RoomMatchGroup interface.
 */
export function instanceOfRoomMatchGroup(value: object): value is RoomMatchGroup {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('creationStatus' in value) || value['creationStatus'] === undefined) return false;
    if (!('confidence' in value) || value['confidence'] === undefined) return false;
    if (!('insurerRooms' in value) || value['insurerRooms'] === undefined) return false;
    if (!('contractorRooms' in value) || value['contractorRooms'] === undefined) return false;
    if (!('lineItemMatchGroups' in value) || value['lineItemMatchGroups'] === undefined) return false;
    return true;
}

export function RoomMatchGroupFromJSON(json: any): RoomMatchGroup {
    return RoomMatchGroupFromJSONTyped(json, false);
}

export function RoomMatchGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomMatchGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comparisonId': json['comparisonId'],
        'creationStatus': json['creationStatus'],
        'confirmationStatus': json['confirmationStatus'] == null ? undefined : json['confirmationStatus'],
        'confidence': json['confidence'],
        'note': json['note'] == null ? undefined : json['note'],
        'insurerRooms': ((json['insurerRooms'] as Array<any>).map(RoomDetailFromJSON)),
        'contractorRooms': ((json['contractorRooms'] as Array<any>).map(RoomDetailFromJSON)),
        'lineItemMatchGroups': ((json['lineItemMatchGroups'] as Array<any>).map(LineItemMatchGroupFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RoomMatchGroupToJSON(json: any): RoomMatchGroup {
    return RoomMatchGroupToJSONTyped(json, false);
}

export function RoomMatchGroupToJSONTyped(value?: Omit<RoomMatchGroup, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'creationStatus': value['creationStatus'],
        'confirmationStatus': value['confirmationStatus'],
        'confidence': value['confidence'],
        'note': value['note'],
        'insurerRooms': ((value['insurerRooms'] as Array<any>).map(RoomDetailToJSON)),
        'contractorRooms': ((value['contractorRooms'] as Array<any>).map(RoomDetailToJSON)),
        'lineItemMatchGroups': ((value['lineItemMatchGroups'] as Array<any>).map(LineItemMatchGroupToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

